import { render } from "./Painel.vue?vue&type=template&id=69e012b8"
import script from "./Painel.vue?vue&type=script&lang=ts"
export * from "./Painel.vue?vue&type=script&lang=ts"
script.render = render

export default script